// Matches possible values in PcmProduct.productName where PcmProduct.productCategory is ValueAddedService
export enum VASType {
  NetflixBasic = 'Netflix Basic',
  NetflixBasis = 'Netflix Basis',
  NetflixStandard = 'Netflix Standard',
  NetflixPremium = 'Netflix Premium',
}

export type VASExplanation = {
  title: string;
  subtitle?: string[];
  text: string[];
};

export function getUniqueSellingPointsTitle(vasTitle: string): string {
  switch (vasTitle as VASType) {
    case VASType.NetflixBasic:
    case VASType.NetflixBasis:
    case VASType.NetflixStandard:
    case VASType.NetflixPremium:
      return 'Netflix';
    default:
      return '';
  }
}

export function getValueAddedServiceExplanation(vasTitle: string): VASExplanation {
  switch (vasTitle as VASType) {
    case VASType.NetflixBasic:
    case VASType.NetflixBasis:
    case VASType.NetflixStandard:
    case VASType.NetflixPremium:
      return {
        title: NetflixExplanationTitle,
        subtitle: NetflixExplanationSubtitles,
        text: NetflixExplanation,
      };
    default:
      return {
        title: '',
        text: [],
      };
  }
}

export function getValueAddedServiceRemovalExplanation(vasTitle: string): VASExplanation {
  switch (vasTitle as VASType) {
    case VASType.NetflixBasic:
    case VASType.NetflixBasis:
    case VASType.NetflixStandard:
    case VASType.NetflixPremium:
      return {
        title: NetflixRemovalExplanationTitle,
        text: NetflixRemovalExplanation,
      };
    default:
      return {
        title: '',
        text: [],
      };
  }
}

export function getUniqueSellingPointList(vasType: string): string[] {
  switch (vasType as VASType) {
    case VASType.NetflixBasic:
    case VASType.NetflixBasis:
      return NetflixBasicUniqueSellingPoints;
    case VASType.NetflixStandard:
      return NetflixStandardUniqueSellingPoints;
    case VASType.NetflixPremium:
      return NetflixPremiumUniqueSellingPoints;
    default:
      return [];
  }
}

export function getExistingValueAddedServiceExplanation(vasTitle: string): string[] {
  switch (vasTitle as VASType) {
    case VASType.NetflixBasic:
    case VASType.NetflixBasis:
    case VASType.NetflixStandard:
    case VASType.NetflixPremium:
      return NetflixExistingExplanation;
    default:
      return [''];
  }
}

const NetflixBasicUniqueSellingPoints: string[] = [
  'Strøm reklamefritt på 1 enhet ',
  'Last ned på 1 enhet',
  'God video- og lydkvalitet',
  'HD 720p-oppløsning',
];

const NetflixStandardUniqueSellingPoints: string[] = [
  'Strøm reklamefritt på 2 enheter samtidig',
  'Last ned på 2 enheter',
  'Svært god video- og lydkvalitet',
  'Full HD 1080p-oppløsning',
];

const NetflixPremiumUniqueSellingPoints: string[] = [
  'Strøm reklamefritt på 4 enheter samtidig',
  'Last ned på 6 enheter',
  'Den beste video- og lydkvalitet',
  '4K oppløsning og HDR',
];

const NetflixExplanationTitle: string = 'Slik fungerer iceMax og Netflix';
const NetflixExplanationSubtitles: string[] = [
  'Hvordan aktiverer man Netflix?',
  'Har kunden allerede en Netflix-konto?',
  'Endre Netflix-abonnement',
];
const NetflixExplanation: string[] = [
  'Kunden må selv aktivere Netflix på Min Side eller i ice-appen. ',
  'Kunden kan bruke sin eksisterende Netflix-konto når de aktiverer Netflix med Ice.',
  'Kunden kan oppgradere og nedgradere sitt Netflix-abonnement på Netflix sine sider.',
];

const NetflixExistingExplanation: string[] = [
  'Netflix Basis er inkludert i iceMax. Kunden kan oppgradere og nedgradere Netflix-Abonnementet inne på sin Netflix-Konto.',
  'Det kan ta inntill 24t før endring av Netflix-pakke blir synlig i Diego.',
];

const NetflixRemovalExplanationTitle: string = 'Hva skjer med Netflix når man bytter abonnement?';
const NetflixRemovalExplanation: string[] = [
  'Netflix vil gjenoppta betaling fra kunden, og kontoen vil fortsette som før. Mister kunden tilgang til Netflix må de oppdatere betalingsinformasjon på sin Netflix-konto. ',
];
